import _ from 'lodash'
import { Map } from 'immutable'

import config from '../../../../config'

import {
    TOGGLE_BLOCK,
    BLOCK_DATA_LOADED,
    BLOCK_DATA_LOAD_FAILED,
    SAVE_CUSTOM_BLOCK_DATA,
    BLOCK_DATA_EMPTY,
    SAVE_IS_SCROLLED,
} from './components/HocBlock/constants'
import { CHANGE_BLOCK_LEVEL } from './components/HocBlock/components/BlockTitle/components/LevelPicker/constants'
import { TABS_TAB_REMOVED } from '../Tabs/constants'

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case TOGGLE_BLOCK: {
            const module = _.get(action, 'data.module', null)
            const id = _.get(action, 'data.id', null)
            const blockKey = _.get(action, 'data.blockKey', null)

            const actualOpen = state.getIn([module, id, 'blocks', blockKey, 'open'], config.components.block.open)

            return state.setIn([module, id, 'blocks', blockKey, 'open'], !actualOpen)
        }
        case BLOCK_DATA_LOADED: {
            const module = _.get(action, 'data.module', null)
            const id = _.get(action, 'data.id', null)
            const blockKey = _.get(action, 'data.blockKey', null)

            const actualOpen = state.getIn([module, id, 'blocks', blockKey, 'open'], null)
            const newOpen = actualOpen === null ? config.components.block.open : actualOpen

            return state
                .setIn([module, id, 'blocks', blockKey, 'open'], newOpen)
                .setIn([module, id, 'blocks', blockKey, 'disable'], false)
                .setIn([module, id, 'blocks', blockKey, 'failed'], false)
        }
        case BLOCK_DATA_EMPTY: {
            const module = _.get(action, 'data.module', null)
            const id = _.get(action, 'data.id', null)
            const blockKey = _.get(action, 'data.blockKey', null)

            return state
                .setIn([module, id, 'blocks', blockKey, 'open'], false)
                .setIn([module, id, 'blocks', blockKey, 'disable'], true)
                .setIn([module, id, 'blocks', blockKey, 'failed'], false)
        }
        case BLOCK_DATA_LOAD_FAILED: {
            const module = _.get(action, 'data.module', null)
            const id = _.get(action, 'data.id', null)
            const blockKey = _.get(action, 'data.blockKey', null)

            return state
                .setIn([module, id, 'blocks', blockKey, 'open'], true)
                .setIn([module, id, 'blocks', blockKey, 'disable'], false)
                .setIn([module, id, 'blocks', blockKey, 'failed'], true)
        }
        case CHANGE_BLOCK_LEVEL: {
            const module = _.get(action, 'data.module', null)
            const id = _.get(action, 'data.id', null)
            const blockKey = _.get(action, 'data.blockKey', null)
            const value = _.get(action, 'data.value', 0)

            if (value === null) return state.deleteIn([module, id, 'blocks', blockKey, 'level'])

            return state.setIn([module, id, 'blocks', blockKey, 'level'], value)
        }
        case SAVE_CUSTOM_BLOCK_DATA: {
            const module = _.get(action, 'data.module', null)
            const id = _.get(action, 'data.id', null)
            const blockKey = _.get(action, 'data.blockKey', null)
            const customData = _.get(action, 'data.customData', {})

            const actualCustomData = state.getIn([module, id, 'blocks', blockKey, 'customData'], {})

            // rewrite on first level of custom data!
            const newCustomData = {
                ...actualCustomData,
                ...customData,
            }

            return state.setIn([module, id, 'blocks', blockKey, 'customData'], newCustomData)
        }
        case TABS_TAB_REMOVED: {
            const module = _.get(action, 'data.type', null)
            const id = _.get(action, 'data.id', null)

            return state.deleteIn([module, id])
        }
        case SAVE_IS_SCROLLED: {
            return state.setIn(['report', 'isScrolled'], action.data)
        }
        default:
            return state
    }
}
